var submitButton = document.querySelector('.cta-search input[type="submit"]'),
    buttonTrigger = document.querySelector('.cta-search .button-trigger');

if (submitButton && buttonTrigger) {
    buttonTrigger.addEventListener('click', function() {
        submitButton.click();
    });
}